marketo();

const navigateToDemoThankYou = () => {
  var url = window.canonicalUrl;
  if (~url.search('/en-au')) window.location.pathname = '/en-au/demo-thank-you';
  else if (~url.search('/en-ca')) window.location.pathname = '/en-ca/demo-thank-you';
  else if (~url.search('/en-gb')) window.location.pathname = '/en-gb/demo-thank-you';
  else window.location.pathname = '/demo-thank-you';
};

function marketo() {
  let marketoIDs = [];

  let styleForm = form => {
    let removeInjectedCssElements = () => {
      let themeLinkElement = document.getElementById('mktoForms2ThemeStyle');
      let baseLinkElement = document.getElementById('mktoForms2BaseStyle');

      if (themeLinkElement) {
        themeLinkElement.remove();
      }

      if (baseLinkElement) {
        baseLinkElement.remove();
      }
    };

    let cleanseForm = () => {
      let formElement = form.getFormElem()[0];
      let formStyleElement = formElement.querySelector('style');
      let buttonWraps = formElement.querySelectorAll('.mktoButtonWrap');
      let submitButton = formElement.querySelector('button[type="submit"]');

      formElement.removeAttribute('style');

      if (formStyleElement) {
        formStyleElement.remove();
      }

      if (buttonWraps) {
        buttonWraps.forEach(e => e.removeAttribute('style'));
      }

      if (submitButton) {
        submitButton.setAttribute('class', 'btn orange');
      }

      formElement.querySelectorAll('.mktoFormRow').forEach(formRow => {
        let mktoElementsToRemoveStyleAttribute = formRow.querySelectorAll(
          'input, select, textarea, .mktoHtmlText, .mktoCheckboxList, .mktoFormCol, .mktoLabel'
        );
        let mktoElementsToRemove = formRow.querySelectorAll('.mktoOffset, .mktoGutter, .mktoClear');
        let isCheckboxField = formRow.querySelectorAll('.mktoCheckboxList').length > 0;
        let isSelectField = formRow.querySelectorAll('select').length > 0;
        let isHiddenInputRow = formRow.querySelectorAll('[type="hidden"]').length;
        let labelElement = formRow.querySelector('.mktoLabel');
        let labelValue = labelElement
          ? labelElement.innerHTML.replace('<div class="mktoAsterix">*</div>', '').trim()
          : '';
        let labelToUpdate = isCheckboxField
          ? formRow.querySelector('.mktoCheckboxList label')
          : formRow.querySelector('.mktoLabel');

        mktoElementsToRemoveStyleAttribute.forEach(element => element.removeAttribute('style'));
        mktoElementsToRemove.forEach(element => element.remove());

        if (isCheckboxField) {
          labelElement.remove();
        }

        if (isSelectField) {
          let icon = document.createElement('i');
          icon.setAttribute('class', 'fas fa-caret-down dropdown');
          document.querySelector('select').parentNode.appendChild(icon);
        }

        if (labelToUpdate) {
          labelToUpdate.innerHTML = labelValue;
        }

        if (isHiddenInputRow) {
          formRow.classList.add('hidden');
        }
      });
    };

    removeInjectedCssElements();
    cleanseForm();
  };

  // Remove existing tid and fid from the URL query params
  // so that they can be added without conflict in the next block
  if (window.location.search.indexOf('fid') > -1) {
    const params = new URLSearchParams(window.location.search);
    params.delete('fid');
    params.delete('tid');
    if (params.toString()) {
      window.history.replaceState(null, null, `?${params.toString()}`);
    } else {
      window.history.replaceState(null, null, window.location.pathname);
    }
  }

  $('[id^=mktoForm_]').each(function() {
    const idAttr = $(this).attr('id');
    const formId = idAttr.substr(idAttr.indexOf('_') + 1);
    marketoIDs.push(formId);

    $(this).on('submit', function() {
      const googleId = docCookies.getGoogleId();
      const randomId = Procore.metrics.page.pageInfo.pageviewID || Math.floor(Math.random() * 1000000000);
      const transactionId = `${googleId}.${randomId}`;
      const params = new URLSearchParams(window.location.search);
      params.set('fid', formId);
      params.set('tid', transactionId);
      window.history.replaceState(null, null, `?${params.toString()}`);
    });
  });

  if (marketoIDs.length > 0) {
    $.getScript(`https://${window.marketoURI}/js/forms2/js/forms2.min.js`, function() {
      MktoForms2.whenReady(function(form) {
        styleForm(form);

        form.onValidate(function() {
          var email = form.vals().Email;

          if (email) {
            var parts = email.split('@');

            if (parts.length === 2) {
              if (parts[1].includes('-procore')) {
                form.submitable(false);
                var emailElem = form.getFormElem().find('#Email');
                form.showErrorMessage('Invalid Email', emailElem);
              }
            }
          }
        });
      });

      marketoIDs.forEach(function(rawMarketoID) {
        let marketoID = parseInt(rawMarketoID);
        let customWebinarForm =
          ['number', 'string'].indexOf(typeof window._cmsCustomWebinarForm) != -1
            ? parseInt(window._cmsCustomWebinarForm)
            : '';

        MktoForms2.loadForm(`//${window.marketoURI}`, '788-HIQ-636', marketoID, function(form) {
          const gAClientID = docCookies.getGoogleId();
          const pushLeadEvent = function(formID) {
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
              event: 'mktoLead',
              mktoFormId: formID
            });

            try {
              const values = form.getValues();
              const company = 'Company' in values && values.Company.length > 0 ? values.Company : '';
              const hasCompany = company.length > 0;

              window.Procore.metrics.user = window.Procore.metrics.user || {};
              window.Procore.metrics.user.hasEmail = 'Email' in values && values.Email.length > 0;
              window.Procore.metrics.user.hasFirstName = 'FirstName' in values && values.FirstName.length > 0;
              window.Procore.metrics.user.hasLastName = 'LastName' in values && values.LastName.length > 0;
              window.Procore.metrics.user.hasCompany = hasCompany;
              window.Procore.metrics.user.gAClientID = gAClientID;
              window.Procore.metrics.user.company = company;

              docCookies.setCookie('pc_mktoLead', btoa(JSON.stringify(window.Procore.metrics.user)), 1);
            } catch (error) {
              console.error('Failed to update Metric User object');
            }
          };

          form.addHiddenFields({
            gAClientID: gAClientID
          });

          if (docCookies.getCookie('pc_geo') == 'US') {
            $('#gDPRFormsConsent')
              .parents('.mktoFormRow')
              .remove();
          }

          form.onSuccess(function() {
            // All Form Successes
            pushLeadEvent(marketoID);

            let formData = form.getValues() || {};
            if ('Routing_Company_Type__c' in formData) {
              pcJourney.setCompanyType(formData['Routing_Company_Type__c']);
            }

            let formElement = document.querySelector(`#mktoForm_${marketoID}`);
            let dataRedirect = formElement.getAttribute('data-redirect');
            let setCookies = formElement.getAttribute('data-set-cookies');
            let successReaction = formElement.getAttribute('data-success-reaction');

            if (formElement) {
              if (dataRedirect) {
                window.location.replace(dataRedirect);
                return false;
              }

              if (setCookies) {
                let cookies = setCookies.split(' ');

                if (cookies.indexOf('tourBypass') !== -1) {
                  docCookies.setCookie('pc_tour_pass', '1', 0.33);
                  location.reload();
                  return false;
                }

                if (cookies.indexOf('gbkLiveByPass8Hour') !== -1) {
                  docCookies.setCookie('pc_gbk_live_pass', '1', 0.33);
                  location.reload();
                  return false;
                }

                if (cookies.indexOf('gbkLiveByPassNoLimit') !== -1) {
                  docCookies.setCookie('pc_gbk_live_pass', '1');
                  location.reload();
                  return false;
                }
              }

              if (successReaction) {
                if (successReaction == 'product-hero') {
                  document.querySelector('.product-hero .form-wrapper').style.display = 'none';
                  document.querySelector('.product-hero .video-wrapper').style.display = 'block';
                  pcJourney.setFormCompleted('2.1');
                  return false;
                }
              }
            }
          });

          if ([5141, 6226, 6221, 6216, 6196].indexOf(marketoID) !== -1) {
            // eBook Landing Page Template
            form.onSuccess(function() {
              docCookies.setCookie('lp_unlock', '1', 31536e3);
              pcJourney.setFormCompleted('1.1');
              location.reload();
              return false;
            });
          } else if (
            [
              5212,
              5519,
              6227,
              6228,
              6222,
              6223,
              6217,
              6218,
              6229,
              6231,
              6807,
              6808,
              6858,
              6859,
              customWebinarForm
            ].indexOf(marketoID) !== -1
          ) {
            // Webinar Landing Page Template
            form.onSuccess(function() {
              docCookies.setCookie('lp_unlock', '1', 31536e3);
              pcJourney.setFormCompleted('1.2');
              location.reload();
              return false;
            });
          } else if (marketoID === 1767) {
            // .ORG Modal
            form.onSuccess(function() {
              pushLeadEvent(marketoID);
              $('#mktoForm_1767').html(
                `<p id="thank-you">Thank you for your interest!</p><p>You'll be hearing from us soon.</p>`
              );
              return false;
            });
          } else if (marketoID === 6916) {
            // Customer Homepage
            form.onSuccess(function() {
              document.querySelector(`form[id=mktoForm_${marketoID}]`).classList.add('hidden');
              document.querySelector(`.cta-subscription-container .success-message`).classList.remove('hidden');
              return false;
            });
          } else if (marketoID === 5390) {
            // Pricing page
            form.onSuccess(function() {
              pushLeadEvent(marketoID);
              $('#modal-form-wrapper').hide();
              $('#modal-thank-you').show();
              return false;
            });
          } else if (marketoID === 4876) {
            // All Request a Demo forms
            form.onSuccess(function() {
              pushLeadEvent(marketoID);
              pcJourney.setFormCompleted('3.1');
              window._vis_opt_queue = window._vis_opt_queue || [];
              window._vis_opt_queue.push(function() {
                _vis_opt_goal_conversion(201);
              });
              let formElement = document.querySelector(`#mktoForm_${marketoID}`);
              let dataRedirect = formElement.getAttribute('data-redirect');
              if (formElement && dataRedirect) {
                window.location.replace(dataRedirect);
              } else {
                navigateToDemoThankYou();
              }
              return false;
            });
          } else if (marketoID === 5992) {
            // Solutions Page Template - Groundbreak Live Registration
            form.onSuccess(function() {
              pushLeadEvent(marketoID);
              docCookies.setCookie('gbklive_subscriber', '1', 31536e3, 'https://www.procore.com/groundbreak/live');
              return false;
            });
          } else if (marketoID === 1243) {
            // Contact Page
            form.onSuccess(function() {
              pushLeadEvent(marketoID);
              form.getFormElem().hide();
              $('#thankyouDiv').css('display', 'block');
              return false;
            });
          } else if (marketoID === 1672) {
            // Contact Page (GBK Footer)
            form.onSuccess(function() {
              pushLeadEvent(marketoID);
              form.getFormElem().hide();
              $('.form-intro').css('display', 'none');
              $('.form-thank-you').css('display', 'block');
              return false;
            });
          } else if (marketoID === 4866) {
            // GBK Live Page
            form.onSuccess(function() {
              pushLeadEvent(marketoID);
              docCookies.setCookie('gbklive_subscriber', '1', 31536e3);
              location.href = 'https://www.procore.com/groundbreak/live';
              return false;
            });
          } else if (marketoID === 6826) {
            // GBK Virtual Signup
            form.onSuccess(function() {
              pushLeadEvent(marketoID);
              form.getFormElem().hide();
              let formIntro = document.getElementById('form-intro');
              formIntro ? (formIntro.style.display = 'none') : null;
              let formThankYou = document.getElementById('form-thank-you');
              formThankYou ? (formThankYou.style.display = 'block') : null;
              return false;
            });
          } else if (marketoID === 2044) {
            // WIC Header
            form.onSuccess(function() {
              pushLeadEvent(marketoID);
              form.getFormElem().hide();
              $('.form-intro').css('display', 'none');
              $('#footerThankyouDiv').css('display', 'block');
              return false;
            });
          } else if (marketoID === 5508) {
            // ROI Calculator
            form.onSuccess(function() {
              pushLeadEvent(marketoID);
              form.getFormElem().hide();
              $('#modal-intro').addClass('hidden');
              $('#modal-thank-you').removeClass('hidden');
              return false;
            });
          }
        });
      });
    });
  }
}
